import React from "react";
import PropTypes from "prop-types";
import HubspotBanner from "../hubspot/HubspotBanner";

const ThrottlingHubspotBanner = (props) => {
  const { varsomeHost } = props;
  return (
    <div>
      <hr className="tw-mb-12 tw-mt-12" />
      <div className="hubspot-container tw-text-center">
        <HubspotBanner
          bannerId="bed27dc4-e114-4db8-a0e5-cfb87bf0de81"
          altText="You can wait for 60 minutes or you can upgrade to Varsome Premium"
          altUrl={`${varsomeHost}/varsome-editions/varsome-premium`}
        />
      </div>
    </div>
  );
};

ThrottlingHubspotBanner.propTypes = {
  varsomeHost: PropTypes.string.isRequired,
};

export default ThrottlingHubspotBanner;
